import { Mail, MapPin, MessageCircle, Phone } from 'lucide-react';
import PageHero from '../components/PageHero';
import Seo from '../components/Seo';
import TextNowLink from '../components/TextNowLink';
import InquiryForm from '../components/InquiryForm';
import { CONTACT } from '../data/siteData';

export default function Contact() {
  return (
    <>
      <Seo title="Request Towing in Richmond BC" description="Need a tow truck, flatbed or roadside assistance in Richmond? Call or text Jonny's Towing at (604) 398-8866, or send a service request for a quote." />
      <PageHero eyebrow="Richmond towing requests" title="Need a Tow Truck in Richmond?" description="Talk to Jonny's Towing dispatch about a tow, flatbed transport or roadside assistance. Share your location and vehicle details for an assessment; availability and pricing are confirmed before booking." image="/images/rolls-royce-flatbed.webp">
        <a className="button button--primary" href={CONTACT.phoneHref} data-roka-cta="call_dispatch" data-roka-label="Call dispatch"><Phone size={18} /> {CONTACT.phoneDisplay}</a>
        <TextNowLink className="button button--ghost"><MessageCircle size={18} /> Text Now</TextNowLink>
      </PageHero>
      <section className="section container contact-layout">
        <aside className="contact-details">
          <span className="eyebrow">Direct contact</span>
          <h2>Tell us what happened.</h2>
          <p>Include your exact location, vehicle details, current condition and intended destination wherever possible.</p>
          <a href={CONTACT.phoneHref} data-roka-cta="call_dispatch" data-roka-label="Call dispatch"><Phone /><span><strong>Call dispatch</strong>{CONTACT.phoneDisplay}</span></a>
          <TextNowLink><MessageCircle /><span><strong>Text dispatch</strong>Share GPS location with permission</span></TextNowLink>
          <a href={`mailto:${CONTACT.email}`}><Mail /><span><strong>Email</strong>{CONTACT.email}</span></a>
          <div><MapPin /><span><strong>Service area</strong>{CONTACT.area}. We come to you.</span></div>
          <div className="notice-card"><strong>Emergency safety</strong><p>Move to a safe location when possible. For collisions involving injuries, immediate danger or blocked high-speed traffic, call 9-1-1 first.</p></div>
        </aside>
        <InquiryForm />
      </section>
    </>
  );
}
